const Layout = (props) => props.children;

export default Layout;